import { render } from "./EmployeePendingApprovalView.vue?vue&type=template&id=5356be66&scoped=true"
import script from "./EmployeePendingApprovalView.vue?vue&type=script&lang=js"
export * from "./EmployeePendingApprovalView.vue?vue&type=script&lang=js"

import "./EmployeePendingApprovalView.vue?vue&type=style&index=0&id=5356be66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5356be66"]])

export default __exports__